export function communicationActorSurface(actor: string): "crm" | "customer" | "public" {
  return actor.startsWith("staff:") ? "crm" : actor.startsWith("guest:") ? "public" : "customer"
}
